import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Persiste en localStorage para sobrevivir recargas en el dispositivo
export const useAuthStore = create(
  persist(
    (set) => ({
      isAuthenticated: false,
      token:    null,
      user:     null,   // { _id, name, email, role }
      tenantId: null,

      login: ({ token, user, tenantId }) =>
        set({ isAuthenticated: true, token, user, tenantId }),

      logout: () =>
        set({ isAuthenticated: false, token: null, user: null, tenantId: null }),
    }),
    {
      name:    'gc-pos-auth',
      partialize: (s) => ({ token: s.token, user: s.user, tenantId: s.tenantId, isAuthenticated: s.isAuthenticated }),
    }
  )
);
